/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShipExclusionUpdateBase
 */
export interface ShipExclusionUpdateBase {
    /**
     * PSI企業ID
     * @type {number}
     * @memberof ShipExclusionUpdateBase
     */
    companyId: number;
    /**
     * PSIセンターID
     * @type {number}
     * @memberof ShipExclusionUpdateBase
     */
    centerId: number;
    /**
     * 商品コード
     * @type {string}
     * @memberof ShipExclusionUpdateBase
     */
    itemCode: string;
    /**
     * 
     * @type {Date}
     * @memberof ShipExclusionUpdateBase
     */
    recDate: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ShipExclusionUpdateBase
     */
    remarks?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ShipExclusionUpdateBase
     */
    shipExclusionFlg?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof ShipExclusionUpdateBase
     */
    stockPlanUpdateDatetime?: Date | null;
}

/**
 * Check if a given object implements the ShipExclusionUpdateBase interface.
 */
export function instanceOfShipExclusionUpdateBase(value: object): value is ShipExclusionUpdateBase {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('centerId' in value) || value['centerId'] === undefined) return false;
    if (!('itemCode' in value) || value['itemCode'] === undefined) return false;
    if (!('recDate' in value) || value['recDate'] === undefined) return false;
    return true;
}

export function ShipExclusionUpdateBaseFromJSON(json: any): ShipExclusionUpdateBase {
    return ShipExclusionUpdateBaseFromJSONTyped(json, false);
}

export function ShipExclusionUpdateBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipExclusionUpdateBase {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'centerId': json['center_id'],
        'itemCode': json['item_code'],
        'recDate': (json['rec_date'] == null ? null : new Date(json['rec_date'])),
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
        'shipExclusionFlg': json['ship_exclusion_flg'] == null ? undefined : json['ship_exclusion_flg'],
        'stockPlanUpdateDatetime': json['stock_plan_update_datetime'] == null ? undefined : (new Date(json['stock_plan_update_datetime'])),
    };
}

export function ShipExclusionUpdateBaseToJSON(json: any): ShipExclusionUpdateBase {
    return ShipExclusionUpdateBaseToJSONTyped(json, false);
}

export function ShipExclusionUpdateBaseToJSONTyped(value?: ShipExclusionUpdateBase | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['companyId'],
        'center_id': value['centerId'],
        'item_code': value['itemCode'],
        'rec_date': value['recDate'] == null ? value['recDate'] : value['recDate'].toISOString(),
        'remarks': value['remarks'],
        'ship_exclusion_flg': value['shipExclusionFlg'],
        'stock_plan_update_datetime': value['stockPlanUpdateDatetime'] == null ? value['stockPlanUpdateDatetime'] : value['stockPlanUpdateDatetime'].toISOString(),
    };
}

